import React, {Component} from 'react';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import SalesClaimAdd from '../SalesClaimAdd/SalesClaimAdd';
import CarClaimItemDetail from '../../CarClaim/CarClaimItemDetail'
import { connect } from 'react-redux';
import axios from 'axios/index';
import * as moment from 'moment';
import { APIURL, IMAGE_FULL_URL } from '../../../config/config'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { AlertWarning } from '../../Alert/Alert'

// import { pdfImageCarCheck } from '../../../config/pdfImage';
// import ThaiBaht from 'thai-baht-text'

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew-Regular.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

class SalesClaim extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      car_sell_id: '',
      form_status: '',
      claim_edit: {},
      car_claim: {},
      car_sell: {},
      car_claim_list: [],
      modal: false,
      modalDelete: false,
      user: JSON.parse(this.props.user),
      claim_status: '',
      carBase64Img: ''
    };

    this.toggleModal= this.toggleModal.bind(this);
    this.salesClaimAdd= this.salesClaimAdd.bind(this);
    this.openClaimAdd= this.openClaimAdd.bind(this);
  }

  componentDidMount () {
    const queryString = require('query-string');
    let car_claim = queryString.parse(this.props.location.search);

    this.setState({
      car_claim: car_claim,
      car_sell_id: car_claim.car_sell_id
    }, () => {
      this.loadCarSellById(); // for addForm, pdf
      this.loadCarClaim();
    });
  }

  async makeCarImgBase64(car_upload_id) {
    try {
      // let car = this.state.car
      await this.loadCarImageBase64(car_upload_id)
    } catch (e) {
      console.log('----makeCarImgBase64 error')
      console.log(e)
    }
  }

  async loadCarImageBase64(car_upload_id) {
    let uri =  APIURL + '/car/image/' + car_upload_id;
    await axios.get(uri)
      .then(res => {
        let body = res.data.body
        this.setState({ carBase64Img: body })
      }).catch(error => {
        console.log('error:', error)
      })
  }

  toggle (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  openClaimAdd() {
    /* start : ออกใบเคลม
    process : กำลังดำเินการซ่อม
    success : ซ่อมเสร็จรอลูกค้ามารับ
    complete : ลูกค้ามารับเรียบร้อย */
    this.setState({
      claim_status: 'start',
      form_status: 'add'
    },()=>{
      this.toggleModal();
    });
  }

  openClaimEdit(claim) {
    /* start : ออกใบเคลม
    process : กำลังดำเินการซ่อม
    success : ซ่อมเสร็จรอลูกค้ามารับ
    complete : ลูกค้ามารับเรียบร้อย */
    this.setState({
      claim_status: 'start',
      form_status: 'edit',
      claim_edit: claim
    },()=>{
      this.toggleModal();
    });
  }

  openClaimDelete(claim) {
    this.setState({
      form_status: 'delete',
      claim_edit: claim
    },()=>{
      this.toggleModalDelete();
    });
  }

  toggleModalDelete() {
    this.setState({
      modalDelete: !this.state.modalDelete
    });
  }

  convertClaimStatusName(statusValue) {
    var statusList = [
      {status: 'start', name: 'ออกใบเคลม'},
      {status: 'process', name: 'กำลังดำเินการซ่อม'},
      {status: 'success', name: 'ซ่อมเสร็จรอลูกค้ามารับ'},
      {status: 'complete', name: 'ปิดเคลม'},
    ];
    var result = statusList.find(status => {
      return status.status === statusValue
    })
    return result.name;
  }

  loadCarSellById () {
    // alert (this.state.car_sell_id)
    axios.get(APIURL + '/car_sell/' + this.state.car_sell_id)
      .then(async res => {
        const car_sell = res.data[0]
        const car_upload_id = car_sell.car_upload_id
        const tent_warranty = car_sell.tent_warranty

        this.setState({ car_sell: car_sell }, async () => {
          await this.makeCarImgBase64(car_upload_id);
        })

      }).catch(error => {
      //alert('error' + error)
      console.log (error)
      this.setState({car_sell: {}})
    })
  }

  salesClaimAdd (event) {
    event.preventDefault();
    // var that = this;
    let claim_date = event.target.claim_date.value;
    let claim_name = event.target.claim_name.value;
    let claim_mobile = event.target.claim_mobile.value;
    let claim1_list1 = event.target.claim1_list1.value;
    let claim1_list2 = event.target.claim1_list2.value;
    let claim2 = event.target.claim2.value;
    let claim3 = event.target.claim3.value;
    let car_id = this.state.car_sell.car_id;
    let user = this.state.user.user;

    const data = {
      claim_date: claim_date,
      claim_name: claim_name,
      claim_mobile: claim_mobile,
      claim1_list1: claim1_list1,
      claim1_list2: claim1_list2,
      claim2: claim2,
      claim3: claim3,
      car_id: car_id,
      user: user
    };

    if(this.state.form_status === 'add') {
      axios.post(APIURL + '/car_claim', data)
        .then((res) => {
          if (res.status === 200) {
            this.toggleModal();
            this.loadCarClaim();
          }
        })
        .catch((err) => {
          console.log(err);
      });
    }else if(this.state.form_status === 'edit'){
      var car_claim_id = this.state.claim_edit.car_claim_id
      axios.put(APIURL + '/car_claim/'+car_claim_id, data)
        .then((res) => {
          if (res.status === 200) {
            this.setState({
              form_status: 'add',
            }, () => {
              this.toggleModal();
              this.loadCarClaim();
            });
          }

        }).catch((err) => {
        console.log(err)
      })
    }
  }

  carClaimDelete(claim_id) {
    if(this.state.form_status === 'delete'){
      axios.delete(APIURL + '/car_claim/' + claim_id).then(res => {
        if (res.status === 200) {
          this.loadCarClaim()
          this.setState({
            form_status: 'add',
            modalDelete: !this.state.modalDelete
          });
        }
      })
    }
  }

  loadCarClaim() {
    axios.get(APIURL + '/car_claim/car/' + this.state.car_claim.car_id)
      .then(res => {
        this.setState({car_claim_list: res.data})
      }).catch(error => {
      //alert('error' + error)
      console.log (error)
      this.setState({car_claim_list: []})
    })
  }

  convertImgToBase64URL(url, callback, outputFormat){
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function(){
      var canvas = document.createElement('CANVAS'),
        ctx = canvas.getContext('2d'), dataURL;
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL(outputFormat);
      callback(dataURL);
      canvas = null;
    };
    img.src = url;
  }


  printClaim(claimData, carData) {
    // var img_car_claim_id = 'img_'+claimData.car_claim_id;
    let claim_date = moment(claimData.claim_date).locale('th').format('LL');
    let claim_name = moment(claimData.claim_name).locale('th').format('LL'); //claimData.claim_name;
    let claim_mobile = claimData.claim_mobile;
    let claim1_list1 = claimData.claim1_list1;
    let claim1_list2 = claimData.claim1_list2;
    let car_brand_name = carData.car_brand_name
    let car_model_name = carData.car_model_name
    let car_color_name = carData.car_color_name
    let car_license_plate_new = carData.car_license_plate_new
    // วันที่ขายรถ car_sell_date : {carClaim.car_sell_date}
    let car_sell_date = moment(claimData.car_sell_date).locale('th').format('LL');
    let is_star = carData.is_star
    let is_star_text = is_star === 0 ? '' : '***รถติดดาว'
    // var car_upload_filename = carData.car_upload_filename
    // var car_url = IMAGE_THUMB_URL+car_upload_filename

    // เกียร์ 2 เดือน แอร์ 1 เดือน
    let  car_garuntee_gear_end_date = moment(claimData.car_sell_date).add(60, 'days').format('ll')
    let  car_garuntee_air_end_date = moment(claimData.car_sell_date).add(30, 'days').format('ll')

    let base64Img = this.state.carBase64Img
    if (this.state.carBase64Img === '') {
      AlertWarning('กรุณารอสักครู่ระบบกำลังโหลดภาพรถ')
      return
    }

    // let base64Img = this.state.carBase64Img

    let gearbox_warranty = claimData.gearbox_warranty === null ? '': claimData.gearbox_warranty
    let gearbox_bank_name = claimData.gearbox_bank_name === null ? '': claimData.gearbox_bank_name
    let gearbox_warranty_expire = claimData.gearbox_warranty === 'รับประกันเครื่องเกียร์' ? moment(claimData.car_sell_date).add(1, 'years').locale('th').format('LL') : '-'

    let tent_warranty = claimData.tent_warranty === null ? '': claimData.tent_warranty
    let customer_mobile = claimData.customer_mobile === null ? '': claimData.customer_mobile

    // 2023-04-03 ประกันเต็นท์ => เกียร์ 2 เดือน แอร์ 1 เดือน
    let gearboxText = ''
    if (gearbox_warranty !== '') {
      if (claimData.gearbox_warranty === 'รับประกันเครื่องเกียร์') {
        // gearboxText = 'ประกันเครื่องเกียร์: ' + gearbox_warranty + '  ธนาคารที่รับประกัน: ' + gearbox_bank_name + '   วันที่หมดประกัน: ' + gearbox_warranty_expire
        gearboxText = 'ประกันธนาคาร: มี ' + gearbox_bank_name +' / ถึงวันที่ ' + gearbox_warranty_expire
      } else if (claimData.gearbox_warranty === 'ไม่รับประกันเครื่องเกียร์'){
       // gearboxText = 'ประกันเครื่องเกียร์: ' + gearbox_warranty
        gearboxText = 'ประกันธนาคาร: ไม่มี'
      } else {
        gearboxText = 'ประกันธนาคาร: ไม่ระบุ'
        // gearboxText = 'ประกันเครื่องเกียร์: ไม่ระบุ'
      }
    } else {
      gearboxText = 'ประกันธนาคาร: ไม่ระบุ'
    }

    /*let gearbox = {
      columns: [
        {
          width: 150,
          text: ''
        },
        {
          width: '80%',
          text: gearboxText ,
          style: 'body'
        },
      ],
      columnGap: 20,
      lineHeight: 1.0,
      margin: [0, 0, 0, 0],
    }

    let gearboxCopy = {
      columns: [
        {
          width: 150,
          text: ''
        },
        {
          width: '80%',
          text: gearboxText ,
          style: 'body'
        },
      ],
      columnGap: 20,
      lineHeight: 1.0,
      margin: [0, 0, 0, 0],
    }*/

    // this.convertImgToBase64URL(car_url, function(base64Img){
    // Base64DataURL
    // (เบอร์โทร ' + claim_mobile+' )
    // text: 'วันที่ออกใบงาน...'+ claim_date+ ' (เบอร์โทรลูกค้า..'+customer_mobile+') \nลูกค้ารับรถ...'+claim_name+' \nหมดรับประกันรถวันที่: '+car_guaruntee_end_date +'\n'+
    //               'รถยี่ห้อ...'+ car_brand_name+'  รุ่น...'+car_model_name+ '   สี...'+ car_color_name +'  ทะเบียน...'+car_license_plate_new
    let claim_detail = 'วันที่ออกใบงาน...'+ claim_date+ ' (เบอร์โทรลูกค้า..'+customer_mobile+') ' +
      // '\nลูกค้ารับรถ...'+claim_name+
      '\nประกันของเต็นท์: '+tent_warranty ;

    if (tent_warranty === 'มี') {
      claim_detail += ' เกียร์ถึงวันที่ ' + car_garuntee_gear_end_date +" , "
      claim_detail += ' แอร์ถึงวันที่ '+ car_garuntee_air_end_date
    }
      // '\nหมดรับประกันรถวันที่: '+car_guaruntee_end_date +
    claim_detail += '\n'+gearboxText
    claim_detail += '\nรถยี่ห้อ...'+ car_brand_name+'  รุ่น...'+car_model_name+ '   สี...'+ car_color_name +'  ทะเบียน...'+car_license_plate_new

    if (is_star === 1) {
      claim_detail += '\n'+is_star_text+' , วันที่ขายรถ : '+car_sell_date
    }else{
      claim_detail += '\nวันที่ขายรถ : '+car_sell_date
    }



    let docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [ 56, 30, 56, 30 ], // margin: [left, top, right, bottom]
      content: [
        { text: 'ออกใบเคลม', style: 'bodyhead', lineHeight:1.3},
        {
          columns: [
            { width: '20%',
              text: '', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: '',
            },
            { width: '20%',
              text: '', style: 'bodycompany'
            },
            { width: '20%', style: 'body',
              text: 'Sale........................',
            },

          ],
          columnGap: 20,
          lineHeight:1
        },
        {
          columns: [
            {
              width: 150,
              image: base64Img
            },
            { width: '80%',
              text: claim_detail
              ,
              style: 'body'
            },
          ],
          columnGap: 20,
          lineHeight:1.3,
          margin: [ 0, 8, 0, 0 ], // margin: [left, top, right, bottom]
        },
        /*{
          columns: [
            { width: '100%',
              text: 'รถยี่ห้อ...'+ car_brand_name+'  รุ่น...'+car_model_name+ '   สี...'+ car_color_name +'  ทะเบียน...'+car_license_plate_new, style: 'textcenter'
            },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          margin: [ 0, 8, 0, 0 ],
        },*/
        // gearbox,
        {
          columns: [
            { width: '100%', text: 'รายการ:', style: 'body' },
          ],
          columnGap: 20,
          margin: [ 0, 8, 0, 0 ], // margin: [left, top, right, bottom]
          lineHeight: 1.5
        },
        {
          columns: [
            { width: '50%', text: claim1_list1 , style: 'body'},
            { width: '50%', text: claim1_list2 , style: 'body'},
          ],
          columnGap: 20,
          margin: [ 8, 0, 0, 0 ], // margin: [left, top, right, bottom]
          lineHeight: 1.3,
        },
        {
          columns: [
            { width: '100%', text: '', style: 'body' },
          ],
          columnGap: 20,
          lineHeight: 1.3
        },
        {
          columns: [
            {
              width: '100%',
              text: 'อนุมัติ....................................   ช่าง:ตรวจ....................................   Sale:ตรวจ....................................   ',
              style: 'textcenter'
            },
          ],
          columnGap: 20,
          lineHeight: 1.5,
          margin: [ 0, 12, 0, 0 ],
        },
        //repeat
        [
          { text: 'ออกใบเคลม', style: 'bodyhead', lineHeight:1.3, margin: [ 0, 16, 0, 0 ],},
          {
            columns: [
              { width: '20%',
                text: '', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: '',
              },
              { width: '20%',
                text: '', style: 'bodycompany'
              },
              { width: '20%', style: 'body',
                text: 'Sale........................',
              },

            ],
            columnGap: 20,
            lineHeight:1
          },
          {
            columns: [
              {
                width: 150,
                image: base64Img
              },
              { width: '80%',
                text: claim_detail,
                style: 'body'
              },
            ],
            columnGap: 20,
            lineHeight:1.3,
            margin: [ 0, 8, 0, 0 ], // margin: [left, top, right, bottom]
          },
          /*{
            columns: [
              {
                width: '100%',
                text: 'รถยี่ห้อ...'+ car_brand_name+'  รุ่น...'+car_model_name+ '   สี...'+ car_color_name +'  ทะเบียน...'+car_license_plate_new,
                style: 'textcenter'
              },
            ],
            columnGap: 20,
            lineHeight: 1.3,
            margin: [ 0, 8, 0, 0 ],
          },*/
          // gearboxCopy,
          {
            columns: [
              { width: '100%', text: 'รายการ:', style: 'body' },
            ],
            columnGap: 20,
            margin: [ 0, 8, 0, 0 ], // margin: [left, top, right, bottom]
            lineHeight: 1.5
          },
          {
            columns: [
              { width: '50%', text: claim1_list1 , style: 'body'},
              { width: '50%', text: claim1_list2 , style: 'body'},
            ],
            columnGap: 20,
            margin: [ 8, 0, 0, 0 ], // margin: [left, top, right, bottom]
            lineHeight: 1.3,
          },
          {
            columns: [
              { width: '100%', text: '', style: 'body' },
            ],
            columnGap: 20,
            lineHeight: 1.3
          },
          {
            columns: [
              {
                width: '100%',
                text: 'อนุมัติ....................................   ช่าง:ตรวจ....................................   Sale:ตรวจ....................................   ',
                style: 'textcenter'
              },
            ],
            columnGap: 20,
            lineHeight: 1.5,
            margin: [ 0, 12, 0, 0 ],
          },
        ]
      ],
      // images: {
      //  carCheck:
      // },
      styles: {
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        body: {
          fontSize: 16,
        },
        bodycompany: {
          fontSize: 16,
          bold: true,
        },
        textcenter: {
          fontSize: 16,
          alignment: 'center'
        },
      },
      defaultStyle: {
        font: 'THSarabunNew'
      }
    };
    //

    pdfMake.createPdf(docDefinition).open()

    // });
  }

  render() {

    let tbodyList = this.state.car_claim_list.map((carClaim, index) => {

      let image_url = ''
      if (carClaim.car_upload_filename.includes('https')) {
        image_url = carClaim.car_upload_filename
      } else {
        image_url = IMAGE_FULL_URL + carClaim.car_upload_filename
      }

      let gearbox_warranty = carClaim.gearbox_warranty === null ? '' : carClaim.gearbox_warranty
      let gearbox_bank_name = carClaim.gearbox_bank_name === null ? '': carClaim.gearbox_bank_name
      let gearbox_warranty_expire = carClaim.gearbox_warranty === 'รับประกันเครื่องเกียร์' ? moment(carClaim.car_sell_date).add(1, 'years').locale('th').format('LL') : '-'

      let tent_warranty = carClaim.tent_warranty === null ? '' : carClaim.tent_warranty

      let gearboxText = ''
      if (gearbox_warranty !== '') {
        if (gearbox_warranty === 'รับประกันเครื่องเกียร์') {
          // gearboxText = 'ประกันเครื่องเกียร์: ' + gearbox_warranty + '  ธนาคารที่รับประกัน: ' + gearbox_bank_name + '   วันที่หมดประกัน: ' + gearbox_warranty_expire
          gearboxText = 'ประกันธนาคาร: ' + gearbox_bank_name + <br/>+' / ถึงวันที่ ' + gearbox_warranty_expire
        } else if (carClaim.gearbox_warranty === 'ไม่รับประกันเครื่องเกียร์'){
          // gearboxText = 'ประกันธนาคาร: ' + gearbox_warranty
          gearboxText = 'ประกันธนาคาร: ไม่มี'
        } else {
          gearboxText = 'ประกันธนาคาร: ไม่ระบุ'
        }
      } else {
        gearboxText = 'ประกันธนาคาร: ไม่ระบุ'
      }

      return (
        <tr key={index}>
          <td className="text-center" width="10%">{carClaim.car_claim_id}</td>
          <td>
            วันที่ออกใบเคลม: {carClaim.claim_date} <br/>
            ลูกค้ารับรถ: {carClaim.claim_name} <br/>
            วันที่ขายรถ  : {carClaim.car_sell_date} <br/>
            เบอร์โทรผู้ส่งเคลม: {carClaim.claim_mobile} <br/>
            เบอร์โทรลูกค้า: {carClaim.customer_mobile} <br/>
            <img id={'img_'+carClaim.car_claim_id} src={image_url} className="img-cars" alt="car"/>
          </td>
          <td>
            รายการ : <br/>
            {carClaim.claim1_list1} <br/>
            {carClaim.claim1_list2} <br/>
            <div className={carClaim.claim2===''? 'hidden': ''}>
            <hr/>
            เคลมที่ 2 : <br/>
            {carClaim.claim2} <br/>
            </div>
            <div className={carClaim.claim3===''? 'hidden': ''}>
              <hr/>
            เคลมที่ 3 : <br/>
            {carClaim.claim3} <br/>
            </div>

            <CarClaimItemDetail car_claim_id = {carClaim.car_claim_id} />

            <br/>
            <strong>
              หมายเหตุ: <br/>
             {/* <span className="text-danger">
                  หมดรับประกันรถวันที่ { moment(carClaim.car_sell_date).add(90, 'days').format('LL')}
              </span> */}
              ประกันของเต็นท์: &nbsp;
              <span className="text-danger">
               {tent_warranty} &nbsp;
                {
                  tent_warranty === 'มี' ?
                    <>
                      เกียร์ถึงวันที่  { moment(carClaim.car_sell_date).add(60, 'days').format('LL')} ,
                       แอร์ถึงวันที่ { moment(carClaim.car_sell_date).add(30, 'days').format('LL')}
                    </>
                    : null
                }
              </span>

            </strong>
            <br/>
            <strong>
              {

                gearbox_warranty === 'รับประกันเครื่องเกียร์' ? <>

                  <hr/>
                  <span >การประกันเครื่องเกียร์: <span className="text-success">{gearbox_warranty}</span></span> <br/>
                  <span>ธนาคารที่รับประกัน: {gearbox_bank_name}</span> <br/>
                  <span>วันที่หมดประกัน: {gearbox_warranty_expire}</span> <br/>

                </> : gearboxText

              }
            </strong>

          </td>
          <td width="10%">
            {this.convertClaimStatusName(carClaim.status)}
          </td>
          <td className="align-top text-center" width="10%" >
            <button onClick={() => {
              this.printClaim(carClaim, this.state.car_sell)
            }}
              type="button" className="btn btn-sm btn-primary btn-md-width">
              <i className="icon-printer"></i> พิมพ์
            </button>

            <button
              className={carClaim.status==='complete'? 'hidden': 'btn btn-sm btn-warning btn-md-width'}
              onClick={() => {
                this.openClaimEdit(carClaim)
              }}
            >
              <i className="fa fa-edit"></i> แก้ไข
            </button>

            <button
              className={carClaim.status==='complete'? 'hidden': 'btn btn-sm btn-danger btn-md-width'}
              onClick={() => {
                this.openClaimDelete(carClaim)
              }}
            >
              <i className="fa fa-remove"></i> ลบ
            </button>

          </td>
        </tr>
      );
    });


    let tbodyEmpty = ()=>{
      return (
        <tr className="text-center">
          <td colSpan={5}><span className="text-danger">ไม่พบข้อมูล</span></td>
        </tr>
      )};

    let is_star = this.state.car_sell.is_star === undefined ? 0 : this.state.car_sell.is_star

    return (
      <div className="col-md-12 mb-4">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({active: this.state.activeTab === '1'})}
              onClick={() => { this.toggle('1') }}
            >
              <i className="icon-options-vertical"></i> ข้อมูลการปล่อยรถ/การเคลม
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong>
                      รายการใบเคลม ทะเบียน&nbsp;
                      {this.state.car_claim.car_license_plate_new}
                      &nbsp;:&nbsp;
                      {this.state.car_claim.car_name}
                      &nbsp;:&nbsp;
                      {this.state.car_claim.date_promise}
                      &nbsp;&nbsp;
                      {
                        is_star === 0 ? '' : <span className="text-danger">(รถติดดาว)</span>
                      }
                    </strong>
                    <button
                      type="button"
                      onClick={this.openClaimAdd}
                      className="btn btn-primary float-right"
                    >
                      <i className="icon-plus"></i>&nbsp; เพิ่ม ปล่อยรถ/เคลม
                    </button>
                    <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={'modal-lg ' + this.props.className}>
                      <ModalBody>
                        <SalesClaimAdd
                          user={this.props.user}
                          car_sell={this.state.car_sell}
                          claim_edit={this.state.claim_edit}
                          form_status = {this.state.form_status}
                          claim_status = {this.state.claim_status}
                          onToggle={this.toggleModal}
                          onSubmit={this.salesClaimAdd}
                        />
                      </ModalBody>
                    </Modal>
                  </div>
                  <div className="card-block">
                    <div className="row">
                      <div className="col-lg-12">
                        <table className="table table-striped">
                          <thead>
                          <tr>
                            <th className="text-center">#</th>
                            <th className="text-center" width="20%">วันออกใบงาน</th>
                            <th>รายการ</th>
                            <th>สถานะ</th>
                            <th className="text-center">จัดการ</th>
                          </tr>
                          </thead>
                          <tbody>
                          {(tbodyList.length>0)? tbodyList: tbodyEmpty()}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabPane>
        </TabContent>

        <Modal isOpen={this.state.modalDelete} toggle={this.toggleModalDelete.bind(this)}
               className={'modal-danger'}>
          <ModalHeader toggle={this.toggleModalDelete.bind(this)}>ลบข้อมูล</ModalHeader>
          <ModalBody>
            <strong> คุณต้องการลบข้อมูล id={this.state.claim_edit.car_claim_id} ใช่หรือไม่ ?? </strong>
            <br />(ข้อมูลจะไม่สามารถกู้คืนได้)
          </ModalBody>
          <ModalFooter>
            <Button color="primary"
                    onClick={this.carClaimDelete.bind(this, this.state.claim_edit.car_claim_id)}>ตกลง</Button>{' '}
            <Button color="secondary" onClick={this.toggleModalDelete.bind(this)}>ยกเลิก</Button>

          </ModalFooter>
        </Modal>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(SalesClaim);
